import CodeSnippet from 'components/CodeSnippet';
import * as CODE from "../../../../src/constants/mms";
import { APIWrapper, LeftColumn, RightColumn } from 'components/ApiRef';
import Notification from 'components/Notification';
import * as React from 'react';
export default {
  CodeSnippet,
  CODE,
  APIWrapper,
  LeftColumn,
  RightColumn,
  Notification,
  React
};